(function () {
  function initVideoSections() {
    document.querySelectorAll('[data-melalight-video]').forEach((section) => {
      const player = section.querySelector('.melalight-video__player');
      const video = section.querySelector('.melalight-video__video');
      const playButton = section.querySelector('.melalight-video__play');

      if (!player || !video || !playButton || playButton.dataset.initialized === 'true') {
        return;
      }

      playButton.dataset.initialized = 'true';

      playButton.addEventListener('click', () => {
        video.controls = true;
        player.classList.add('is-playing');

        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            player.classList.remove('is-playing');
          });
        }
      });

      video.addEventListener('pause', () => {
        if (video.currentTime === 0 || video.ended) {
          player.classList.remove('is-playing');
        }
      });

      video.addEventListener('ended', () => {
        player.classList.remove('is-playing');
        video.controls = false;
        video.currentTime = 0;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoSections);
  } else {
    initVideoSections();
  }

  document.addEventListener('shopify:section:load', initVideoSections);
})();
